import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import TrendingRoutes from './TrendingRoutes';
import WhyBooking from './WhyBooking';
import "../App.css";

// ===== BACKGROUND SLIDER IMAGES (src/Content/Flight_Images) =====
import slide1 from "../Content/Flight_Images/Slider1.png";
import slide2 from "../Content/Flight_Images/Slider2.jpg";
import slide3 from "../Content/Flight_Images/Slider3.jpg";


function Index() {
    const navigate = useNavigate();

    const [tripType, setTripType] = useState("O"); // O = One Way, R = Round Trip

    // ✅ FIX: isSearching state ab component ke andar hai
    const [isSearching, setIsSearching] = useState(false);

    const [from, setFrom] = useState({
        city: "Delhi",
        code: "DEL",
        name: "Indira Gandhi International Airport"
    });

    const [to, setTo] = useState({
        city: "Mumbai",
        code: "BOM",
        name: "Chatrapati Shivaji International Airport"
    });

    const [departDate, setDepartDate] = useState("");
    const [returnDate, setReturnDate] = useState("");
    const [departDisplay, setDepartDisplay] = useState({});
    const [returnDisplay, setReturnDisplay] = useState({});

    // Travelers & Class State
    const [adults, setAdults] = useState(1);
    const [children, setChildren] = useState(0);
    const [infants, setInfants] = useState(0);
    const [travelClass, setTravelClass] = useState("Economy");
    const [showTravelerDropdown, setShowTravelerDropdown] = useState(false);

    // Airport data states
    const [airports, setAirports] = useState([]);
    const [fromQuery, setFromQuery] = useState("Delhi");
    const [toQuery, setToQuery] = useState("Mumbai");
    const [fromSuggestions, setFromSuggestions] = useState([]);
    const [toSuggestions, setToSuggestions] = useState([]);

    // ===== BACKGROUND SLIDER STATE =====
    const [currentSlide, setCurrentSlide] = useState(0);

    const bgSlides = [slide1, slide2, slide3];

    // Refs
    const fromRef = useRef(null);
    const toRef = useRef(null);
    const travelerRef = useRef(null);
    const departInputRef = useRef(null);
    const returnInputRef = useRef(null);



useEffect(() => {
    const loadAirports = async () => {
        console.log("🚀 Airport loading started...");

        // Pehle LocalStorage check
        const storedAirports = localStorage.getItem("airports");
        if (storedAirports) {
            try {
                const parsed = JSON.parse(storedAirports);
                if (Array.isArray(parsed) && parsed.length > 0) {
                    console.log(`✅ Loaded ${parsed.length} airports from localStorage`);
                    setAirports(parsed);
                    return;
                }
            } catch (e) {
                console.error("❌ LocalStorage corrupted:", e);
                localStorage.removeItem("airports");
            }
        }

        console.log("🌐 Fetching airports from API using POST...");

        try {
            const res = await fetch("https://api.namantechnolab.com/api/Air/Airports", {
                method: 'POST',          
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({

                })  
            })
            if (!res.ok) {
                throw new Error(`HTTP error! Status: ${res.status}`);
            }
            const data = await res.json();
            console.log("📦 API Response:", data);

            const actualArray = Array.isArray(data) 
                ? data 
                : (data?.data && Array.isArray(data.data) ? data.data : []);

            if (actualArray.length > 0) {
                setAirports(actualArray);
                localStorage.setItem("airports", JSON.stringify(actualArray));
                console.log(`✅ SUCCESS: Saved ${actualArray.length} airports to localStorage`);
            } else {
                console.warn("⚠️ API returned empty data");
            }
        } catch (err) {
            console.error("❌ API Fetch Failed:", err.message);
        }
    };

    loadAirports();
}, []);
    // Bahar click karne par dropdowns band karo
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (fromRef.current && !fromRef.current.contains(event.target)) {
                setFromSuggestions([]);
            }
            if (toRef.current && !toRef.current.contains(event.target)) {
                setToSuggestions([]);
            }
            if (travelerRef.current && !travelerRef.current.contains(event.target)) {
                setShowTravelerDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
useEffect(() => {
    const loadAirports = async () => {
        console.log("🚀 Airport loading started...");

        // Pehle LocalStorage check
        const storedAirports = localStorage.getItem("airports");
        if (storedAirports) {
            try {
                const parsed = JSON.parse(storedAirports);
                if (Array.isArray(parsed) && parsed.length > 0) {
                    console.log(`✅ Loaded ${parsed.length} airports from localStorage`);
                    setAirports(parsed);
                    return; // API call skip
                }
            } catch (e) {
                console.error("❌ LocalStorage data corrupted:", e);
                localStorage.removeItem("airports");
            }
        }

        // API se fetch karo
        console.log("🌐 Fetching airports from API...");
        try {
         const AIRPORTS_ENDPOINT = process.env.NODE_ENV === "development"
  ? "/api/Air/Airports"                          // proxy ke through (CORS fix)
  : `${process.env.REACT_APP_API_BASE_URL}/Air/Airports`; // production direct
debugger;
const res = await fetch(AIRPORTS_ENDPOINT, {
    method: 'GET',
    headers: { 'Accept': 'application/json' }
});

            if (!res.ok) {
                throw new Error(`HTTP error! Status: ${res.status}`);
            }

            const data = await res.json();
            console.log("📦 API Response received:", data);

            const actualArray = Array.isArray(data) 
                ? data 
                : (data?.data && Array.isArray(data.data) ? data.data : []);

            if (actualArray.length > 0) {
                setAirports(actualArray);
                localStorage.setItem("airports", JSON.stringify(actualArray));
                console.log(`✅ SUCCESS: Saved ${actualArray.length} airports to localStorage`);
            } else {
                console.warn("⚠️ API returned empty array");
            }
        } catch (err) {
            console.error("❌ API Fetch Failed:", err.message);
        }
    };

    loadAirports();
}, []);
useEffect(() => {
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);

        const todayStr = today.toISOString().split('T')[0];
        const tomorrowStr = tomorrow.toISOString().split('T')[0];

        setDepartDate(todayStr);
        setReturnDate(tomorrowStr);

        updateDateDisplay(today, setDepartDisplay);
        updateDateDisplay(tomorrow, setReturnDisplay);
    }, []);

    // ===== BACKGROUND SLIDER AUTO-PLAY =====
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % bgSlides.length);
        }, 4000); // har 4 second me background change hoga
        return () => clearInterval(interval);
    }, []);

    const updateDateDisplay = (date, setter) => {
        if (!date || isNaN(date.getTime())) return;
        const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        setter({
            day: date.getDate(),
            month: months[date.getMonth()],
            year: date.getFullYear(),
            dayName: dayNames[date.getDay()]
        });
    };

    // From aur To swap karo
    const handleSwap = () => {
        const tempFrom = from;
        const tempTo = to;
        setFrom(tempTo);
        setTo(tempFrom);
        setFromQuery(tempTo.city);
        setToQuery(tempFrom.city);
    };

    const handleDepartDateChange = (e) => {
        if (!e.target.value) return;
        const newDate = new Date(e.target.value);
        setDepartDate(e.target.value);
        updateDateDisplay(newDate, setDepartDisplay);
    };

    const handleReturnDateChange = (e) => {
        if (!e.target.value) return;
        const newDate = new Date(e.target.value);
        setReturnDate(e.target.value);
        updateDateDisplay(newDate, setReturnDisplay);
    };

    // Airport filter function
    const getFilteredAirports = (query) => {
        if (!Array.isArray(airports)) return [];
        const cleanQuery = (query || "").trim().toLowerCase();
        return airports.filter(a =>
            (a.CityName && a.CityName.toLowerCase().includes(cleanQuery)) ||
            (a.AirportCode && a.AirportCode.toLowerCase().includes(cleanQuery)) ||
            (a.AirportName && a.AirportName.toLowerCase().includes(cleanQuery))
        );
    };
   const handleInputFocus = (type) => {
    const query = type === "from" ? fromQuery : toQuery;
    console.log(`Focus - ${type} | Query: "${query}" | Total Airports: ${airports.length}`);

    if (query.trim().length >= 3 && airports.length > 0) {
        const filtered = getFilteredAirports(query);
        if (type === "from") setFromSuggestions(filtered.slice(0, 10));
        else setToSuggestions(filtered.slice(0, 10));
    }
};
    const handleFromChange = (e) => {
        const value = e.target.value;
        setFromQuery(value);

        if (value.trim().length >= 3) {
            const filtered = getFilteredAirports(value);
            setFromSuggestions(filtered.slice(0, 10));
        } else {
            setFromSuggestions([]); // 3 se kam — suggestions chhupao
        }
    };
    const handleToChange = (e) => {
        const value = e.target.value;
        setToQuery(value);

        if (value.trim().length >= 3) {
            const filtered = getFilteredAirports(value);
            setToSuggestions(filtered.slice(0, 10));
        } else {
            setToSuggestions([]); // 3 se kam — suggestions chhupao
        }
    };

    const selectFromAirport = (airport) => {
        setFrom({ city: airport.CityName, code: airport.AirportCode, name: airport.AirportName });
        setFromQuery(airport.CityName);
        setFromSuggestions([]);
    };

    const selectToAirport = (airport) => {
        setTo({ city: airport.CityName, code: airport.AirportCode, name: airport.AirportName });
        setToQuery(airport.CityName);
        setToSuggestions([]);
    };

    const handleSearch = (e) => {
        e.preventDefault();
   const routs = [
        {
            Source: from.code,
            InputSource: `${from.code} - ${from.name}`,
            Destination: to.code,
            OutputSource: `${to.code} - ${to.name}`,
            TravelDate: departDate
        }
    ];

    if (tripType === "R") {
        routs.push({
            Source: to.code,
            InputSource: `${to.code} - ${to.name}`,
            Destination: from.code,
            OutputSource: `${from.code} - ${from.name}`,
            TravelDate: returnDate   // ← return date
        });
    }
        const payload = {
            "APIToken": null,
            "AgencyKey": "02AD68F3-9AE6-4148-85B1-E61D1F03991F",
            "AdultCount": Number(adults) || 1,
            "ChildCount": Number(children) || 0,
            "InfantCount": Number(infants) || 0,
            "PreferredAirlines": null,
            "Routs": routs,
            "TripType": tripType === "O" ? 0 : 1,
            "TypeOfClass": 0,
            "IsDomestic": true,
            "SetAirport": null,
            "IsB2B": false,
            "IsSpecailFlight": false,
            "FromCity": null,
            "Tocity": null,
            "TransactionId": 0,
            "EngineType": 0,
            "AccountNo": 11
        };

        const queryParams = new URLSearchParams({
            origin: from.code,
            destination: to.code,
            date: departDate,
            trip: tripType
        }).toString();

console.log("Navigating with URL:", `/AirResponse/Index?${queryParams}`);

navigate(`/AirResponse/Index?${queryParams}`, { state: { searchData: payload } });
    };

    return (
        <div>
            <section className="sec_eng" style={{ position: "relative", overflow: "hidden" }}>
                <div style={{ position: "absolute", inset: 0, zIndex: 0 }}>
                    {bgSlides.map((img, idx) => (
                        <div
                            key={idx}
                            style={{
                                position: "absolute",
                                inset: 0,
                                backgroundImage: `url(${img})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                opacity: currentSlide === idx ? 1 : 0,
                                transition: "opacity 1.5s ease-in-out"
                            }}
                        />
                    ))}
                    {/* Dark overlay taaki upar ka content readable rahe */}
                    <div style={{ position: "absolute", inset: 0, background: "rgba(0,20,60,0.35)" }} />
                </div>
             <div className="slider-dots">
    {bgSlides.map((_, idx) => (
        <span
            key={idx}
            onClick={() => setCurrentSlide(idx)}
            style={{
                width: "10px", height: "10px", borderRadius: "50%", 
                background: currentSlide === idx ? "#fff" : "rgba(255,255,255,0.5)",
                cursor: "pointer", transition: "background 0.3s"
            }}
        />
    ))}
</div>
                <div className="container" style={{ position: "relative", zIndex: 1 }}>
                    <h2 className="engHead">Domestic & International Flights</h2>
                    <div className="eng_top">
                        <div className="radio_full">
                            <input
                                type="radio"
                                className="rbtn1"
                                name="search-type"
                                id="rbtn-oneway"
                                checked={tripType === "O"}
                                onChange={() => setTripType("O")}
                            />
                            <label htmlFor="rbtn-oneway">One Way</label>

                            <input
                                type="radio"
                                className="rbtn1"
                                name="search-type"
                                id="rbtn-roundtrip"
                                checked={tripType === "R"}
                                onChange={() => setTripType("R")}
                            />
                            <label htmlFor="rbtn-roundtrip">Round Trip</label>
                        </div>
                    </div>

                    <form onSubmit={handleSearch}>
                        <div id="flight-onecity" className="eng_row">

                            {/* ===== FROM FIELD ===== */}
<div className="eng_col1" ref={fromRef}>
    <div id="from-Box" style={{ position: "relative" }}>
        <span className="eng_lbl">From</span>
        
        <input   type="text"        value={fromQuery}
            onChange={handleFromChange}
            onFocus={() => handleInputFocus("from")}
            placeholder={fromQuery.length === 0 ? "Enter city or airport" : ""}   // ← Yeh change
            autoComplete="off"
            style={{ 
                border: 'none', 
                width: '100%', 
                fontSize: '24px',      
                fontWeight: '700',
                color: '#000',
                padding: '6px 0 2px 0',
                background: 'transparent'
            }}
        />
        
        {/* Airport Code + Name - Chhota text */}
        <span className="Airport_Name" style={{ 
            fontSize: '13px', 
            color: '#555',
            display: 'block',
            marginTop: '2px'
        }}>
            {from.code} - {from.name}
        </span>

        {/* Suggestions */}
        {fromSuggestions.length > 0 && (
            <ul className="suggestions" style={{
                position: "absolute", zIndex: 100,
                background: "#fff", width: "100%",
                listStyle: "none", padding: "10px",
                border: "1px solid #ccc", maxHeight: "250px",
                overflowY: "auto", boxShadow: "0 4px 8px rgba(0,0,0,0.1)"
            }}>
                {fromSuggestions.map((airport, index) => (
                    <li
                        key={airport.ID || index}
                        onClick={() => selectFromAirport(airport)}
                        style={{
                            cursor: "pointer", padding: "10px 8px",
                            borderBottom: "1px solid #f0f0f0"
                        }}
                    >
                        <strong>{airport.CityName} ({airport.AirportCode})</strong>
                        <div style={{ fontSize: "12px", color: "#666" }}>{airport.AirportName}</div>
                    </li>
                ))}
            </ul>
        )}
    </div>

    {/* Swap Button */}
    <span className="swap" onClick={handleSwap} style={{ cursor: "pointer" }}>
        <span className="icon_swap">⇄</span>
    </span>
</div>

                          {/* ===== TO FIELD ===== */}
<div className="eng_col1" ref={toRef}>
    <div id="to-Box" style={{ position: "relative" }}>
        <span className="eng_lbl">To</span>
        
        <input
            type="text"
            value={toQuery}
            onChange={handleToChange}
            onFocus={() => handleInputFocus("to")}
            placeholder={toQuery.length === 0 ? "Enter city or airport" : ""}  
            autoComplete="off"
            style={{ 
                border: 'none', 
                width: '100%', 
                fontSize: '24px',      
                fontWeight: '700',
                color: '#000',
                padding: '6px 0 2px 0',
                background: 'transparent'
            }}
        />
        
        {/* Airport Code + Name */}
        <span className="Airport_Name" style={{ 
            fontSize: '13px', 
            color: '#555',
            display: 'block',
            marginTop: '2px'
        }}>
            {to.code} - {to.name}
        </span>

        {/* Suggestions */}
        {toSuggestions.length > 0 && (
            <ul className="suggestions" style={{
                position: "absolute", zIndex: 100,
                background: "#fff", width: "100%",
                listStyle: "none", padding: "10px",
                border: "1px solid #ccc", maxHeight: "250px",
                overflowY: "auto", boxShadow: "0 4px 8px rgba(0,0,0,0.1)"
            }}>
                {toSuggestions.map((airport, index) => (
                    <li
                        key={airport.ID || index}
                        onClick={() => selectToAirport(airport)}
                        style={{
                            cursor: "pointer", padding: "10px 8px",
                            borderBottom: "1px solid #f0f0f0"
                        }}
                    >
                        <strong>{airport.CityName} ({airport.AirportCode})</strong>
                        <div style={{ fontSize: "12px", color: "#666" }}>{airport.AirportName}</div>
                    </li>
                ))}
            </ul>
        )}
    </div>
</div>
                            {/* ===== DEPARTURE DATE ===== */}
                            <div className="eng_col2">
                                <div
                                    id="calendar-bo"
                                    className="calendar_box"
                                    onClick={() => departInputRef.current?.showPicker()}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <span className="eng_lbl"><i className="iconCalendar"></i> Departure</span>
                                    <input
                                        ref={departInputRef}
                                        type="date"
                                        className="txtCalendar"
                                        value={departDate}
                                        onChange={handleDepartDateChange}
                                    />
                                    <span className="rowDate">
                                        <span className="lblDay">{departDisplay.day} </span>
                                        <span className="lblMonth">{departDisplay.month}</span>
                                        <span className="lblYear">{departDisplay.year}</span>
                                    </span>
                                    <span className="lblDayName">{departDisplay.dayName}</span>
                                </div>
                            </div>

                            {/* ===== RETURN DATE (sirf Round Trip mein) ===== */}
                            {tripType === "R" && (
                                <div className="eng_col2" id="return-date">
                                    <div
                                        id="calendar-box2"
                                        className="calendar_box"
                                        onClick={() => returnInputRef.current?.showPicker()}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <span className="eng_lbl"><i className="iconCalendar"></i> Return</span>
                                        <input
                                            ref={returnInputRef}
                                            type="date"
                                            className="txtCalendar"
                                            value={returnDate}
                                            onChange={handleReturnDateChange}
                                            min={departDate}
                                        />
                                        <span className="rowDate">
                                            <span className="lblDay">{returnDisplay.day}</span>
                                            <span className="lblMonth">{returnDisplay.month}</span>
                                            <span className="lblYear">{returnDisplay.year}</span>
                                        </span>
                                        <span className="lblDayName">{returnDisplay.dayName}</span>
                                    </div>
                                </div>
                            )}

                            {/* ===== TRAVELER & CLASS ===== */}
                            <div className="eng_col3" ref={travelerRef} onClick={() => setShowTravelerDropdown(!showTravelerDropdown)}>
                                <div id="traveller-box" className="traveller_box">
                                    <span className="eng_lbl">Traveler & Class</span>
                                    <div className="pax_display">{adults + children + infants} Traveler(s)</div>
                                    <span className="lblTravClass">{travelClass}</span>
                                </div>

                                {showTravelerDropdown && (
                                    <div
                                        className="traveler_dropdown"
                                        onClick={(e) => e.stopPropagation()}
                                        style={{
                                            position: "absolute", zIndex: 120,
                                            background: "#fff", padding: "20px",
                                            border: "1px solid #ccc", borderRadius: "8px",
                                            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                            width: "280px", marginTop: "5px"
                                        }}
                                    >
                                        {[
                                            { label: "Adults", sub: "12+ yrs", val: adults, set: setAdults },
                                            { label: "Children", sub: "2 - 12 yrs", val: children, set: setChildren },
                                            { label: "Infants", sub: "under 2 yrs", val: infants, set: setInfants }
                                        ].map((item, idx) => {
                                            const isAdultOrChild = item.label === "Adults" || item.label === "Children";
                                            const canIncrease = isAdultOrChild ? (adults + children < 9) : (infants < 9);
                                            const canDecrease = item.label === "Adults" ? item.val > 1 : item.val > 0;

                                            return (
                                                <div key={idx} style={{
                                                    display: "flex", justifyContent: "space-between",
                                                    alignItems: "center", marginBottom: "15px"
                                                }}>
                                                    <div>
                                                        <div style={{ fontWeight: "600" }}>{item.label}</div>
                                                        <div style={{ fontSize: "12px", color: "#666" }}>{item.sub}</div>
                                                    </div>
                                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                        <button type="button" disabled={!canDecrease} onClick={() => item.set(item.val - 1)}>-</button>
                                                        <span style={{ fontWeight: "600", width: "20px", textAlign: "center" }}>{item.val}</span>
                                                        <button type="button" disabled={!canIncrease} onClick={() => item.set(item.val + 1)}>+</button>
                                                    </div>
                                                </div>
                                            );
                                        })}

                                        <div style={{ marginTop: "10px" }}>
                                            <div style={{ fontWeight: "900", marginBottom: "8px" }}>Select Travel Class</div>
                                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
                                                {["Economy", "Premium Economy", "Business", "First Class"].map((cls) => (
                                                    <button
                                                        key={cls}
                                                        type="button"
                                                        onClick={() => setTravelClass(cls)}
                                                        style={{
                                                            padding: "10px", border: "1px solid #ddd",
                                                            background: travelClass === cls ? "#f0f0f0" : "#fff",
                                                            cursor: "pointer", borderRadius: "4px"
                                                        }}
                                                    >
                                                        {cls}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>

                                        <button
                                            type="button"
                                            onClick={() => setShowTravelerDropdown(false)}
                                            style={{ marginTop: "20px", width: "100%", padding: "8px", cursor: "pointer" }}
                                        >
                                            Done
                                        </button>
                                    </div>
                                )}
                            </div>

                            {/* ===== SEARCH BUTTON ===== */}
                            <div className="eng_col4 p2 me-3">
                                <button type="submit" className="btn_search ms-4">Search</button>
                            </div>

                        </div>
                    </form>
                </div>
            </section>

            <TrendingRoutes />
            <WhyBooking />
        </div>
    );
}

export default Index;